import algoliasearch from 'algoliasearch/lite';
import { createRef, default as React, useState, useMemo } from 'react';
import { InstantSearch } from 'react-instantsearch-dom';
import SearchBox from './SearchBox';
import SearchResult from './SearchResult';
import { useSearchKeyboardEvents } from './useSearchKeyboardEvents';
import Dialog from '@mui/material/Dialog';

export function Search({ indices }) {
  const rootRef = createRef();
  const [isOpen, setIsOpen] = React.useState(false);

  const onOpen = React.useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  const onClose = React.useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const [query, setQuery] = useState();
  const [hasFocus, setFocus] = useState(false);
  const searchClient = useMemo(
    () =>
      algoliasearch(
        process.env.GATSBY_ALGOLIA_APP_ID,
        process.env.GATSBY_ALGOLIA_SEARCH_KEY
      ),
    []
  );
  useSearchKeyboardEvents({ isOpen, onOpen, onClose });
  return (
    <Dialog onClose={onClose} open={isOpen}>
      <div
        className={`relative my-3`}
        ref={rootRef}
        // onKeyDown={(e) => {
        //   if (e.key == 'Enter') alert('hey!');
        // }}
      >
        <InstantSearch
          searchClient={searchClient}
          indexName={indices[0].name}
          onSearchStateChange={({ query }) => setQuery(query)}
        >
          <SearchBox
            onFocus={() => setFocus(true)}
            hasFocus={hasFocus}
            className={`flex flex-row-reverse items-center m-2 p-2 ${
              hasFocus ? 'border' : 'border-0'
            } border-red-300 rounded`}
          />
          <SearchResult indices={indices} className="p-4" />
        </InstantSearch>
      </div>
    </Dialog>
  );
}
